import { Component, EventEmitter, Output } from "@angular/core";
import { NavbarSegment } from "@ponder-features/header/navbar/navbar.component";
import { PreviewItemComponent } from "@ponder-shared/previewItem/preview-item.component";
import { FilteredPreviewItems } from "@ponder-shared/tools/filter/filtered-preview-items";
import { PreviewItemFilters } from "@ponder-shared/tools/filter/preview-item-filters";
import { ScreenBreakpoint } from "@ponder-shared/utils/screenBreakpoints";

@Component({
    template: "",
    standalone: false
})
export class UIEvents {
    @Output()
    public windowResizeEvent: EventEmitter<WindowResizeEvent> = new EventEmitter();

    @Output()
    public windowScrollEvent: EventEmitter<WindowScrollEvent> = new EventEmitter();

    @Output() 
    public headerSizeChangeEvent: EventEmitter<any> = new EventEmitter();

    @Output()
    public displaySidebarEvent: EventEmitter<any> = new EventEmitter();

    @Output()
    public displayErrorEvent: EventEmitter<DisplayErrorEvent> = new EventEmitter();

    @Output()
    public navbarUpdateEvent: EventEmitter<NavbarSegment[]> = new EventEmitter();

    @Output()
    public hideNavbarEvent: EventEmitter<any> = new EventEmitter();

    @Output()
    public showNavbarEvent: EventEmitter<any> = new EventEmitter();

    @Output()
    public previewItemsFetchedEvent: EventEmitter<FilteredPreviewItems> = new EventEmitter();

    @Output()
    public previewItemFilterReadyEvent: EventEmitter<any> = new EventEmitter();

    @Output()
    public previewFilterChangeEvent: EventEmitter<PreviewItemFilters> = new EventEmitter();

    @Output()
    public toggleSortFilterBarEvent: EventEmitter<boolean> = new EventEmitter();

    @Output()
    public itemVisibilityRecalculatedEvent: EventEmitter<any> = new EventEmitter();

    @Output()
    public togglePreviewItemContextMenuEvent: EventEmitter<PreviewItemContextMenuEvent> = new EventEmitter();

    @Output()
    public enteredCollectionEvent: EventEmitter<any> = new EventEmitter();

    @Output()
    public removeContentPaddingEvent: EventEmitter<any> = new EventEmitter();

    @Output()
    public restoreContentPaddingEvent: EventEmitter<any> = new EventEmitter();

    @Output()
    public previewItemControlsToggledEvent: EventEmitter<any> = new EventEmitter();

    @Output()
    public onEditCancelled: EventEmitter<any> = new EventEmitter();

    @Output()
    public onNotificationsUpdated: EventEmitter<any> = new EventEmitter();
}

export class WindowResizeEvent {
    public width!: number;
    public height!: number;
    public breakpoint!: ScreenBreakpoint;
}

export class WindowScrollEvent {
    public prevYOffset!: number;
    public currYOffset!: number;
    public scrolledDown!: boolean;
    public scrolledUp!: boolean;
}

export class PreviewItemContextMenuEvent {
    public itemComponent?: PreviewItemComponent;
    public clickX!: number;
    public clickY!: number;
}

export class DisplayErrorEvent {
    public message!: string;
    public durationSec?: number;
}